import { Spin, Flex, Typography, theme } from "antd";
import { useStore } from "store";
import { LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;

import FloatingCard from "../../../Shared/FloatingCard";

import "./style.scss";
const styleWrapperClass = "modalLogoutOverlay";

export default function LogoutOverlay() {
  const isLoggingOut = !!useStore((state) => state.system.isLoggingOut);

  const LogoutCard = () => {
    const { token: theme_token } = theme.useToken();

    return (
      <FloatingCard>
        <Flex align="center" vertical>
          <LoadingOutlined
            style={{ fontSize: "30px", color: theme_token.colorSecondary }}
          />
          <Title level={4}>Cerrando sesión...</Title>
        </Flex>
      </FloatingCard>
    );
  };

  return (
    <span className={styleWrapperClass}>
      <Spin
        fullscreen
        indicator={<></>}
        tip={<LogoutCard />}
        spinning={isLoggingOut}
      ></Spin>
    </span>
  );
}
